import operations from '~/helpers/device-operations';
import { lastData, type } from '~/helpers/fields-description';
import { netcomTransport } from '~/helpers/network-fields-description';
import { BehaviorKey, Operation } from '~/interfaces/device.interface';
import { FieldObject } from '~/interfaces/field.interface';
import { Gateway } from '~/models/gateways/gateway.model';
import { getServerNodeFields } from '~/models/helpers/network.function';

export class NHC extends Gateway {
    MAX_TIME_BEFORE_CONSIDERED_DISCONNECTED = 10 * 60;
    hasOperationMainloop = false;

    behaviorFields: BehaviorKey[] = [
        'led_disabled',
        'touch_disabled',
    ];

    get deviceOperations(): Operation[] {
        return super.deviceOperations.concat([
            operations.dump({ callback: this.dump }),
            operations.dumpLogs({ callback: this.dumpLogs }),
            operations.logs({ callback: this.logs }),
            operations.orderReboot({ callback: this.orderReboot, disabled: this.isOrderRebootDisabled }),
            operations.setDump({ callback: this.setDump }),
            operations.deleteCache({ callback: this.deleteCache }),
            operations.recalibrateCO2({ callback: this.recalibrateCO2 }),
        ]);
    }

    get typeToDisplay() {
        return this.subtype ? 'NHC-PRO' : this.type;
    }

    loadData(data: any) {
        data.name = data.name || data.module_name;
        super.loadData(data);
        this.loadOffset(data.offset);
    }

    get fieldType() {
        return type(this.type, this.typeToDisplay);
    }
    get fieldLastData() {
        return lastData(this.last_data);
    }

    getNetworkFields(): FieldObject[] {
        let fields: FieldObject[] = super.getNetworkFields();
        if (this.network) {
            fields = fields.concat([
                netcomTransport(this.network.netcom_transport),
            ]);
            if (this.network.server_node) {
                fields = fields.concat(getServerNodeFields(this.network.server_node));
            }
        }
        return fields;
    }
}
